import type { FaireProductEntity } from "../../entity_types/product";

export const p_deadw8djxj: FaireProductEntity = {
  token: "p_deadw8djxj",
  type: "product",
  name: "Matcha Sifter Tea Strainer",
  brandToken: "b_jkddc7grcu",
  brandName: "rocky's matcha",
  imageUrl: "https://cdn.faire.com/fastly/35fc5a1df4938d40595d5eb1d1d5cd387059d38cfe6e8e9d5c7802fdecdaeba8.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/88d3234aa4c032fe958666d5e6d8b50ac06bb6ff4a554c5928d2a5f7774940dc.png"
  ],
  priceDollars: 10,
  description: "Made from stainless steel, this fine mesh matcha tea sifter (strainer) is the perfect tea accessory to help you prepare a cup of matcha with no clumps. Dishwasher safe.",
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-07T19:04:22.064Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
